import request from "./request";

// 网盘列表
export const reuqestGetNetworkDiskList = (accountId: string, params?: any) => {
    return request('get', `/api/netdisc/pathTree/${accountId}`, params)
}

// 添加网盘路径
export const reuqestAddWebDiskPath = (accountId: string, params?: any, callback?: any) => {
    return request('progress', `/api/netdisc/pathTree/refresh/${accountId}`, params, callback)
}

// 同步网盘路径
export const reuqestSynchronizationWebDiskPath = (accountId: string, params?: any) => {
    return request('post', `/api/netdisc/pathTree/refresh/${accountId}`, params)
}

// 删除网盘路径
export const reuqestSyncPathDel = (accountId: string, params?: any) => {
    return request('delete', `/api/netdisc/pathTree/${accountId}`, params)
}

// 获取图片元数据列表
export const reuqestGetPictureMetadataList = (accountId: string, params?: any) => {
    return request('get', `/api/image/meta/${accountId}`, params)
}

// 获取我的网盘目录
export const reuqestGetNetworkLocationCatalogue = (accountId: string, params?: any) => {
    return request('get', `/api/netdisc/pathTree/synced/${accountId}`, params)
}

// 全部图片
export const reuqestAllImage = (params: any) => {
    return request('get', `/api/image/meta/user/full`, params)
}

// 同步进行中的全部图片
export const requestTaskAllImage = (params: any) => {
    return request('get', `/api/image/meta/user/full/task`, params)
}

// 我的收藏
// export const excellingTopic = () => {
//     return request('get', `/api/favorites/tree`)
// }
export const excellingTopic = (params?: any) => {
    return request('get', `/api/excelling/topic`, params)
}
//讨论组
export const topicUser = (params?: any) => {
    return request('get', `/api/excelling/topic/user`)
}
// 创建主题
export const reuqestCreatFavorite = (params: any) => {
    return request('post', `/api/excelling/topic`, params)
}

// 修改主题名称
export const putExcellingTopic = (id: any, params?: any) => {
    return request('put', `/api/excelling/topic/${id}`, params)
}
// 创建子主题
export const putCreatSonsubject = (id: any, operate: any, params?: any) => {
    return request('put', `/api/excelling/topic/${id}/${operate}`, params)
}
//获取新建根目录id
export const sequenceSerial = () => {
    return request('get', `/api/memo/permission/meta/sequence/serial`,)
}

// 删除主题
export const reuqestDelFavorite = (id: string) => {
    return request('delete', `/api/excelling/topic/${id}`)
}
export const getExcellingTopic = (id: string) => {
    return request('get', `/api/excelling/topic/${id}`)
}

//移除主题监听
export const deleteListener = (id: string) => {
    return request('delete', `/api/excelling/topic/${id}/listener`)
}
//创建主题监听
export const createListener = (id: string) => {
    return request('post', `/api/excelling/topic/${id}/listener`)
}
//查询便签
export const getMemo = (id: any, params?: any) => {
    return request('get', `/api/excelling/topic/${id}/external/memo`, params)
}


//修改便签
export const putMemo = (id: string, params: any) => {
    return request('put', `/api/excelling/memo/${id}`, params)
}
//删除便签
export const deleteMemo = (id: string) => {
    return request('delete', `/api/excelling/memo/${id}`)
}
//删除关系
export const deleteBelong = (id: string) => {
    return request('delete', `/api/excelling/relation/belong_to/${id}`)
}
//上传头像
export const rubikFile = (id: string) => {
    return request('put', `/api/rubik/file_placeholder`)
}

//修改关系
export const putBelong = (id: string, params: any) => {
    return request('put', `/api/excelling/relation/belong_to/${id}`, params)
}
//隶属关系查询接口
export const getBelongTo = (id: string, params: any) => {
    return request('get', `/api/excelling/topic/${id}/relation/belong_to`, params)
}
// 获取图片详情信息
export const reuqestImageDetails = (key: string) => {
    return request('get', `/api/placeholder/file_placeholder/${key}`)
}

// 修改主题位置
export const reuqestPutNodePlace = (params: any) => {
    return request('put', `/api/favorites/move`, params)
}

// 向主题中添加图片
export const reuqestAddFavoriteImage = (params: any) => {
    return request('post', `/api/favorites/img`, params)
}

// 删除主题中的图片
export const reuqestDelFavoriteImage = (params: any) => {
    return request('delete', `/api/favorites/img/${params.favoritesId}/${params.key}`)
}

// 获取同步完成的文件夹
export const requestAllSyncCatalogue = (accountId: string) => {
    return request('get', `/api/netdisc/pathTree/chooseSynced/${accountId}`)
}

// 获取我的收藏元数据列表
export const requestCollectList = (favoritesId: string, params: any) => {
    return request('get', `/api/favorites/img/${favoritesId}`, params)
}

// 获取未分类收藏元数据列表
export const requestFavoritesNo = (favoritesId: string, params: any) => {
    return request('get', `/api/favorites/getFavoritesNo${favoritesId ? `/${favoritesId}` : ''}`, params)
}

// 获取未分类收藏元数据列表
export const requestGPS = (params?: any) => {
    return request('get', `/api/image/meta/user/gps`, params)
}
// 查询相似度图片
export const requestSimi = (params?: any) => {
    return request('get', `/api/image/meta/user/similarity`, params)
}

// 获取当前用户分享链接
export const getShareUrl = (params?: any) => {
    return request('post', `/api/share/getShareUrl`, params)
}
// 分享主题
export const favoritesShare = (id?: any, params?: any) => {
    return request('put', `/api/excelling/topic/${id}/share`, params)
}
// 取消分享主题
export const deleteFavoritesShare = (id?: any, params?: any) => {
    return request('delete', `/api/excelling/topic/${id}/share`, params)
}
//保存任务标签
export const putMemoTask = (memoId?: any, params?: any) => {
    return request('put', `/api/excelling/tag/memo/${memoId}/task`, params)
}
//保存任务标签
export const putMemoNotation = (memoId: any, notation: any, params?: any) => {
    return request('put', `/api/excelling/tag/memo/${memoId}/${notation}`, params)
}
//删除任务标签
export const delMemoNotation = (memoId: any, notation: any, params?: any) => {
    return request('delete', `/api/excelling/tag/${notation}/${memoId}`,)
}
//查看markDown内容
export const convertHtml = (params?: any) => {
    return request('put', `/api/excelling/content/convert/html`, params)
}
//保存版本计划
export const putMemoRelease = (memoId: any, params?: any) => {
    return request('put', `/api/excelling/tag/memo/${memoId}/ReleaseTag`, params)
}
//保存图片格式
export const putMemoImageTag = (memoId: any, params?: any) => {
    return request('put', `/api/excelling/tag/memo/${memoId}/ImageTag`, params)
}
//保存图片注释
export const putMemoImgNotesTag = (memoId: any, params?: any) => {
    return request('put', `/api/excelling/tag/memo/${memoId}/ImgNotesTag`, params)
}
//标签台账查询接口
export const tagMeta = (memoId?: any, params?: any) => {
    return request('get', `/api/excelling/tag/tagMeta`, params)
}
//查询任务便签
export const memoLask = (params?: any) => {
    return request('get', `/api/excelling/tag/memo/task`, params)
}
//获取当前登录用户指定主键的通知消息
export const noticeId = (id?: any) => {
    return request('get', `/api/rubik/broadcast/notice/${id}`)
}
//日历统计任务数
export const statsTask = (year: any, type: any, params: any) => {
    return request('get', `/api/calendar/stats/${year}/${type}/task`, params)
}
//根据主键更新类别标注的实例数据
export const putLabelTag = (notation: any, params: any) => {
    return request('put', `/api/rubik/meta/LabelTag/instance/${notation}`, params)
}
//office 相关接口
export const getOfficeKey = (id: any, tag: any) => {
    return request('get', `/api/only/office/file/${id}/${tag}/key`,)
}
//office 相关接口
export const getOfficeToken = ( params:any) => {
    return request('post', `/api/only/office/token`,params)
}

